/* eslint-disable import/no-unused-modules */ // This is the application entry point
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import { changeHtmlLangAttribute } from "./utility/locale-helper";
import RootChecklistUI from "./rootChecklistUI";
import { get as getCookie } from "js-cookie";
import { worker } from "./mocks/browser";

export async function main() {
  // register msw to mock browser api
  if (process.env.NODE_ENV === "development" && !getCookie("ash-hydra-country")) {
    if (window.location.pathname === "/checklist") {
      window.location.pathname = "/checklist/";
      return;
    }

    const { worker } = require("./mocks/browser");

    await worker.start({
      serviceWorker: {
        url: "/checklist/mockServiceWorker.js",
      },
    });
  }

  ReactDOM.render(<RootChecklistUI />, document.getElementById("ASHContentRoot"));
}

changeHtmlLangAttribute();
main();
